import * as React from "react";
import { CoachSettings } from "@/interfaces";
import { usePlayerSettings, useSocialCoachSession } from "@/utils";

import "./styles.scss";
import { PlayerHashTagsForm, PlayerShortLinkForm, PlayerStickersForm } from "@/containers/Coach/EditPlayer/components";

export function PlayerMyCustomizations() {
  const { playerId } = useSocialCoachSession();
  const { hasSetting } = usePlayerSettings(playerId);
  const showCustomStickersSection = hasSetting(CoachSettings.PLAYER_CUSTOM_STICKERS, true);
  const showHashTagSection = hasSetting(CoachSettings.PLAYER_HASHTAG, true);

  return (
    <div className="w-full max-w-5xl">
      <div className={"grid grid-cols-2 gap-6"}>
        {playerId && <PlayerShortLinkForm playerId={playerId} />}

        {showHashTagSection && playerId && <PlayerHashTagsForm playerId={playerId} />}

        {showCustomStickersSection && playerId && (
          <div className="col-span-2">
            <PlayerStickersForm playerId={playerId} withWritePermission={true} />
          </div>
        )}
      </div>
    </div>
  );
}
